import { type Enum } from '@webapp/infrastructure/types/Enum'

export const CatalogItemTagVariants = {
  DEFAULT: 'default',
  SUCCESS: 'success',
  WARNING: 'warning',
  STRONG: 'strong',
  MUTED: 'muted',
  DEAL: 'deal',
} as const

export type CatalogItemTagVariant = Enum<typeof CatalogItemTagVariants>
